/**
 * EU AI Act Art. 50 — visible labeling for AI-generated venue/event imagery.
 *
 * Today every Pulse venue/event cover is AI-generated stock, so callers can
 * show the badge unconditionally via {@link shouldShowAiImageBadge}.
 *
 * Future (Vendor Portal Phase 2 — venue details with vendor-uploaded
 * `photo_url`): pass per-image `isAiGenerated` (DB flag, no migration in this
 * ticket) so real vendor photos are not labeled.
 */
export const AI_IMAGE_I18N = {
  namespace: "consumer",
  badgeAriaKey: "media.aiImageBadgeAria",
  badgeLabelKey: "media.aiImageBadge",
  hintKey: "media.aiImageHint",
  sheetTitleKey: "media.aiImageTitle",
} as const;

export type AiImageLabelInput = {
  /**
   * When Pulse stores real venue photos, set this from `is_ai_generated`
   * (or equivalent) on the image row. Omit / true → show badge.
   */
  isAiGenerated?: boolean | null;
};

/** Whether the AI attribution badge should render for this image. */
export function shouldShowAiImageBadge(
  input: AiImageLabelInput = {},
): boolean {
  if (input.isAiGenerated === false) return false;
  return true;
}
